import { Controller } from '@hotwired/stimulus';

import '@campact/camper/icons/CmprIconSolidCircleChevronDown';

export default class DescriptionController extends Controller {
  static targets = ['shortDescription', 'fullDescription'];

  click() {
    this.shortDescriptionTarget.style.display = 'none';
    this.fullDescriptionTarget.style.display = 'initial';
  }
}
